/**
 * RecommendedLink — reusable external link partial.
 *
 * Automatically applies:
 *   - target="_blank"
 *   - rel="sponsored nofollow noopener"
 *
 * Usage:
 *   <RecommendedLink href="/veil-recommends/infosec-fundamentals" className="my-class">
 *     Link text
 *   </RecommendedLink>
 *
 * Site: veil-framework
 */
import React from "react";

export default function RecommendedLink({ href, children, className, ...rest }) {
  return (
    <a
      href={href}
      target="_blank"
      rel="sponsored nofollow noopener"
      className={className}
      {...rest}
    >
      {children}
    </a>
  );
}
